import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from 'react-select';

import "./ExternalUnit.css"

import history from "../../../../history";
import { getAllUsers } from "../../../../actions/userActions";
import { getAllUnits } from "../../../../actions/structureActions";
import { getExternalUnit, toggleExternalUnitActive } from "../../../../actions/externalUnitActions";

import Modal from "../../../CustomViews/Modal";

class ExternalUnit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            modalType: "",
            modalAction: null
        };
    }

    componentDidMount() {
        this.props.getAllUsers();
        this.props.getAllUnits();
        this.props.getExternalUnit(this.props.match.params.externalOuID);
    }

    renderUnitsOptions = (prefix, units) => {
        let options = []
        units.forEach(unit => {
            options.push({ label: `${prefix} ${unit.symbol} | ${unit.name}`, value: unit.ouID });
            options = [
                ...options,
                ...this.renderUnitsOptions(`${prefix}_`, unit.subOUs)
            ]
        })
        return options
    };

    renderUsers = (users = null) => users.map(user => {
        return (
            <div className="ui segment-wrapper" key={user.userID}>
                <div className="ui segment" onClick={() => this.linkTo(`/users/details/${user.userID}`)}>
                    {this.renderUser(user)}
                </div>
            </div>
        );
    });

    renderUser = (user = null) => {
        return (
            <div className={`ui${user ? "" : " header"} grid`}>
                <div className="four wide column">
                    <div className="content">{user ? user.userID : "Numer ewidencyjny"}</div>
                </div>
                <div className="six wide column">
                    <div className="content">{user ? `${user.lname} ${user.fname}` : "Nazwisko i imię"}</div>
                </div>
                <div className="six wide column">
                    <div className="content">{user ? user.email : "Email"}</div>
                </div>
            </div>
        );
    };

    linkTo = destination => history.push(destination);

    onOperationClick = (type, externalOuID) => this.setState({
        modal: true,
        modalType: type,
        modalAction: externalOuID
    });

    renderModal = () => {
        if (this.state.modalType === "toggleActive") {
            return (
                <Modal
                    title={`${this.props.externalUnit.active === 1 ? "Zablokowanie" : "Odblokowanie"} firmy zewnętrznej`}
                    content={(
                        <React.Fragment>
                            <p>Czy na pewno chcesz {this.props.externalUnit.active === 1 ? "zablokować" : "odblokować"} tę firmę zewnętrzną?</p>
                            <p>Pracownicy przypisani do tej firmy {this.props.externalUnit.active === 1 ? "nie" : "ponownie"} będą mogli zalogować się do panelu.</p>
                        </React.Fragment>
                    )}
                    actions={(
                        <React.Fragment>
                            <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                            <button onClick={() => this.props.toggleExternalUnitActive(this.state.modalAction)} className="ui negative button">{this.props.externalUnit.active === 1 ? "Zablokuj" : "Odblokuj"}</button>
                        </React.Fragment>
                    )}
                    onDismiss={() => history.go(0)}
                />
            );
        }
    };

    render() {
        return (
            <React.Fragment>
                <div className="external-unit-component ui container">
                    <div className="ui three item menu">
                        <Link to="/structure" className="active item">
                            <div className="content">Struktura firmy</div>
                        </Link>
                        <Link to="/absence/reasons" className="item">
                            <div className="content">Przyczyny absencji</div>
                        </Link>
                        <Link to="/settings" className="item">
                            <div className="content">Pozostałe ustawienia</div>
                        </Link>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        <div className="ui two column grid">
                            <div className="column">
                                <Select
                                    onChange={value => this.linkTo(`/structure${value.value ? `/unit/${value.value}` : ""}`)}
                                    options={[{ label: "Medcom", value: null }, ...this.renderUnitsOptions("_", this.props.unitsList)]}
                                    placeholder="Wyszukaj jednostkę organizacyjną..."
                                    noOptionsMessage={() => "Nie znaleziono jednostki organizacyjnej"}
                                    maxMenuHeight="600px"
                                />
                            </div>
                            <div className="column">
                                <Select
                                    onChange={value => this.linkTo(`/users/details/${value.value}`)}
                                    options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u.userID } })]}
                                    placeholder="Wyszukaj użytkownika..."
                                    noOptionsMessage={() => "Nie znaleziono użytkownika"}
                                    maxMenuHeight="600px"
                                />
                            </div>
                        </div>
                        <div className="ui divider" />
                        <div className="ui two column grid">
                            <div className="column" onClick={() => this.linkTo("/structure")}>
                                <h2 className="ui icon header">
                                    <i className="arrow alternate circle up icon"></i>
                                    <div className="header">Medcom</div>
                                </h2>
                            </div>
                            <div className="column">
                                <h2 className="ui icon header">
                                    <i className="building icon"></i>
                                    <div className="header">{this.props.externalUnit.name}</div>
                                </h2>
                            </div>
                        </div>
                        <div className="ui divider" />
                        <div className="ui large header">
                            <div className="content">Informacje&ensp;</div>
                            <div className="small content">
                                ( <Link to={`/structure/external/edit/${this.props.externalUnit.externalOuID}`}>Edytuj</Link> )
                            </div>
                            <div className="small content">
                                ( <span className="clickable red content" onClick={() => this.onOperationClick("toggleActive", this.props.externalUnit.externalOuID)}>{this.props.externalUnit.active === 1 ? "Zablokuj" : "Odblokuj"}</span> )
                            </div>
                        </div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="header">Aktywna:</td>
                                    <td className={`${this.props.externalUnit.active !== 1 ? "red" : ""} content`}>{this.props.externalUnit.active === 1 ? "Tak" : "Nie"}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="ui divider" />
                        <div className="ui large header">
                            <div className="content">Koordynator firmy</div>
                        </div>
                        {this.renderUser()}
                        {this.renderUsers([{
                            userID: this.props.externalUnit.coordinatorID,
                            email: this.props.externalUnit.coordinatorEmail,
                            fname: this.props.externalUnit.coordinatorFname,
                            lname: this.props.externalUnit.coordinatorLname,
                        }])}
                        <div className="ui divider" />
                        <div className="ui large header">
                            <div className="content">Pracownicy firmy&ensp;</div>
                            <div className="small content">
                                ( <Link to={`/structure/external/edit/employees/${this.props.externalUnit.externalOuID}`}>Edytuj</Link> )
                            </div>
                        </div>
                        {this.props.externalUnit.employees.filter(employee => employee.userID !== this.props.externalUnit.coordinatorID).length ? (
                            <React.Fragment>
                                {this.renderUser()}
                                {this.renderUsers(this.props.externalUnit.employees.filter(employee => employee.userID !== this.props.externalUnit.coordinatorID))}
                            </React.Fragment>
                        ) : (
                            <div className="ui small header">
                                <div className="content">Brak pracowników firmy</div>
                            </div>
                        )}
                    </div>
                </div>
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    unitsList: state.structure.list,
    usersList: state.user.list,
    externalUnit: state.externalUnit.current
});

export default connect(mapStateToProps, { getAllUsers, getAllUnits, getExternalUnit, toggleExternalUnitActive })(ExternalUnit);